import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Careers from './Component/careers/Careers';
import { GutentagSearchWebsite } from './Component/search-website';
import { GutentagLayout, GotphotoLayout, NewGotphotoLayout } from './Component/layouts';

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<GotphotoLayout/>}>
                    <Route path="/careers" element={<Careers />} exact/>
                    <Route path="/draft-career-page-2" element={<Careers />} exact/>
                </Route>
                <Route element={<NewGotphotoLayout/>}>
                </Route>
                <Route element={<GutentagLayout/>}>
                    <Route path="/search-website" element={<GutentagSearchWebsite />} exact/>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default Router;
